import React, { useEffect, useState} from 'react';

import { Fragment } from 'react';
import { useHistory } from 'react-router-dom';
import { trackEvent, trackAddToCart, trackViewItem, trackReadMore } from '../utils/analytics';

const Product = (props) => {
    const [showModal, setShowModal] = useState(false);
    const history = useHistory(); 
    
    const openModal = (itemId) =>{
        // Track Read More click with funnel tracking
        trackReadMore(itemId, props.description);
        
        props.showModal(itemId);
    }
 
    useEffect(() => {
        const _ids = process.env.CustIdMoreInfoModal.split(",");
        setShowModal(_ids.indexOf(props.pCustId)>=0);
    },[props.pCustId]);

    useEffect(() => {
        PriceAndStockHandler(props.custItem);
    },[props.custItem]);
    
    const AddToCartHandler = (e, itemId) => {
        e.preventDefault();
        
        // Track Add to Cart click
        trackAddToCart(itemId, props.description, props.listPrice || '0', 1);
        
        if (window?.customEmbedOverrides?.AddToCartHandler) {
            window.customEmbedOverrides.AddToCartHandler(e, itemId);
          } else {
            // Default logic
            console.log("Default Add to Cart", itemId);

            let _url = '/sku/' + itemId
            
            history.push(_url);
          }
    } 

    const PriceAndStockHandler = (itemId) => {
        // Track product view when price/stock is loaded
        if (itemId && props.description) {
            trackViewItem(itemId, props.description, props.categoryParent || 'Parts', props.listPrice || '0');
        }
        
        if (window?.customEmbedOverrides?.InjectStockAndPrice) {
            window.customEmbedOverrides.InjectStockAndPrice(itemId);
          }
    } 

    const handleDealerLocatorClick = () => {
        // Track Dealer Locator click
        trackEvent('dealer_locator_click', {
            event_category: 'embed_interaction',
            event_label: 'dealer_locator',
            product_id: props.custItem,
            product_description: props.description,
            customer_id: props.pCustId
        });
    };

    const displayButtons = (itemId) =>
    {
            return <div className="d-flex gap-2">
                {  showModal && props.pCustId=="711442" && (
                
                    <a href="https://www.sierraparts.com/en-us/find-a-dealer" 
                        onClick={handleDealerLocatorClick}
                        className="btn btn-sm btn-success rounded-pill border w-auto text-nowrap">Dealer Locator</a>
                
                )}
                
                    <a onClick={() =>  openModal(props.productId)} 
                        className="btn btn-sm btn-light rounded-pill border w-auto text-nowrap">Read More</a>
                
                { props.custItem && (
                    //props.searchType == 'simple' &&
                    <a data-cartbutton={itemId} onClick={(e) => AddToCartHandler(e, props.custItem)} 
                        className="btn btn-sm btn-primary rounded-pill w-auto text-nowrap">Add to Cart</a>
                
                )}
            </div>
    }

    return (
        <div className="result-item" key={props.passedKey}>
            <div className="row">
                <div className="result-image">
                    <figure>
                        {props.imagePath ? <img src={process.env.IMAGE_PATH + "/tr:w-70/" + props.imagePath} alt={props.description} /> : null}
                    </figure>
                </div>
                <div className="result-id">
                    <span className="saleItem" title={props.custItem ? props.custItem : props.saleItem}>{props.saleItem}</span>
                </div>
                <div className="result-description">
                    <h4>{props.description}</h4>
                    <span>{props.categoryParent}</span> / <span>{props.categoryChild}</span>
                    {props.oeNumber ? <Fragment><br /><span>OEM part: {props.oeNumber}</span></Fragment> : null}

                </div>
                <div className="result-link">
                    <div className="d-flex flex-column justify-content-center align-items-end">
                        <div className="button-group d-flex gap-1 mb-2">
                            {displayButtons(props.custItem)}
                        </div>
                        <div className="stock-message fw-light text-end d-flex align-items-center justify-content-end">
                            <div data-inv={props.custItem} className="d-inline-flex align-items-center me-2"></div>
                            <span data-sku={props.custItem} className="product-price fw-bold text-muted">{props.listPrice}</span>
                            
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}



export default Product;